import React from "react"
import { graphql } from "gatsby"
import Layout from "../components/layout.js"
import GRMcontactForm from "../components/grm-contact-form.js"
import parse from 'html-react-parser'
import { PrepMedia } from "../utils/globalUtils.js"

import GRMbreadcrumbs from "../components/grm-breadcrumbs.js"
import SEOhead from "../components/seo.js"
import HeadCSS from "../components/headCss.js"

const PlainPostTemplate = ({ data }) => {
	let { 
		title, 
		customContent, 
		categories, 
		language
	} = data.wpPost
	let langCode = ( language ) ? language.slug : 'en'
	let localTrans = {
		gtvpTrans: {
			'en': 'Go to Video Page >',
			'es-co': 'Ir a la página de video >',
			'es-pe': 'Ir a la página de video >',
			'pt-br': 'Ir para a página de vídeo >',
		},
		sadTrans: {
			'en': 'Schedule a Demo',
			'es-co': 'Agende una demostración',
			'es-pe': 'Agende una demostración',
			'pt-br': 'Agende uma demonstração',
		},
		wvTrans: {
			'en': 'Watch Video',
			'es-co': 'Ver video',
			'es-pe': 'Ver video',
			'pt-br': 'Assistir vídeo',
		},
		ctaHeadTrans: {
			'en': 'Do you have questions about ECM application? '+
				'Our experts would love to talk to you!',
			'es-co': '¿Tiene preguntas sobre la aplicación ECM? '+
				'¡A nuestros expertos les encantaría hablar con usted!',
			'es-pe': '¿Tiene preguntas sobre la aplicación ECM? '+
				'¡A nuestros expertos les encantaría hablar con usted!',
			'pt-br': 'Você tem dúvidas sobre a aplicação ECM? '+
				'Nossos especialistas adorariam conversar com você!',
		},
		rvTrans: {
			'en': 'Related Videos',
			'es-co': 'Videos relacionados',
			'es-pe': 'Videos relacionados',
			'pt-br': 'Vídeos relacionados',
		},
	}
	let categoryTitle = categories.nodes[0].name
	let categoryUri = categories.nodes[0].uri
	let categoryId = categories.nodes[0].databaseId
	let elementorCssKit = JSON.parse(data.wp.elementorCssKit)
	let videoCatArray = [
		994,
		3970,
		3978,
		4321,
	]
	let elementorHF = JSON.parse(data.wp.elementorHF)

	customContent = customContent || ''

	let recentPosts = ( videoCatArray.includes(categoryId) ) ?
		data.allWpPost.nodes : []

	let extraClasses = ( videoCatArray.includes(categoryId) ) ? 
		'elementor-column elementor-col-75' : ''
	
	customContent = customContent.replace(/(href=")/gm, 'data-lang="'+ langCode +'" href="')

	const catPattern = '(?<=\{)\s*[^{]*?\"catID\":'+ categoryId +'(?=[\},])'
	const catMatch = data.wp.grmPaginationPages.match(new RegExp(catPattern, 'gm'))
	const catJson = ( catMatch ) ?
		'{'+ catMatch[0] +'}' : null
	const catUri = ( catJson ) ? 
		JSON.parse(catJson).uri : 
		categoryUri

	

	return(
		<Layout className={'grm-post local cat-' +categoryId }
				langCode = { langCode }
				activeKitId={elementorCssKit.activeKitId}
				headerContent={elementorHF.header[langCode].content}
				footerContent={elementorHF.footer[langCode].content}>
			{
				categoryId !== 4923 &&
				<div className="elementor-section elementor-section-boxed">
					<div className="elementor-container"
							style={{
								flexDirection: 'column',
							}}>
								

						<GRMbreadcrumbs title={categoryTitle} 
							langCode={langCode} uri={catUri} />

						<header className={"elementor-column "+
								"elementor-col-100 elementor-top-column" }>
							
							<h1 className="elementor-heading-title elementor-size-large">
								{ title }
							</h1>
						</header>

					</div>
				</div>
			}
			<div className="elementor-section elementor-section-boxed">
                <div className="elementor-container"
						style={{
							flexWrap: 'wrap',
						}}>
					<div className={ "content "+ extraClasses }
							style={{
								flexDirection: 'column',
							}}>
						{ parse(customContent, { replace: PrepMedia }) }
						{
							videoCatArray.includes(categoryId) &&
							<div className="grm-video-cta "
									style={{
										width: '100%',
										textAlign: 'center'
									}}>
								<div>
									<h2 className="text-center cta-heading">
										{localTrans.ctaHeadTrans[langCode]}
									</h2>
								</div>
								<div>
									<a href="#contact-us"
										className="elementor-button secondary"
										role="button">
											{localTrans.sadTrans[langCode]}
									</a>

								</div>
							</div>
						}
					</div> 
					{
						videoCatArray.includes(categoryId) &&
						<>
						<div className={"grm-video-related  elementor-column "+ 
								"elementor-col-25 elementor-top-column"}>
							<div className="inner">
								<h2 className="related-heading">
									{localTrans.rvTrans[langCode]}
								</h2>
								<div className="grm-video-related-wrap">
								{
									recentPosts.map(
										prop => {
											let { id, title, uri, featuredImage } = prop
											let image = ( featuredImage )
												? featuredImage.node.localFile.publicURL 
												: null

											return (
												<article key={ id } 
														className="grm-vr">
													<a href={ uri } title={ title }
															className="text-center">
														{
															image !== null && 
															<img width={430}
																src={ image }
																loading="lazy"
																alt={featuredImage.altText} />
														}
													</a>
													<span className="grm-watch-video-card">
														<i className="fas fa-video" style={{
															marginRight: '6px',
															color: '#1475DF',
														}}></i>
														{ localTrans.wvTrans[langCode] }
													</span>
													<div className="grm-vr-meta">
														<h3 className="grm-vr-heading
																text-center">
															<a href={ uri } 
																title={ title }>
																	{ title }
															</a>
														</h3>
													</div>
												</article>
											)
										}
									)
								}
								</div>
								<a href={categoryUri}
										className="grm-vr-more"
										title={categoryTitle}>
									{ localTrans.gtvpTrans[langCode] }
								</a>
							</div>
						</div>
						
						<style type="text/css" dangerouslySetInnerHTML={{
							__html: ".grm-video-cta h2.cta-heading,.grm-video-related .grm-vr h3 a{font-family:FuturaPT-Book,'Trebuchet MS',sans-serif;color:#292929}.grm-video-cta{margin-top:3.5rem;margin-bottom:3.5rem}.grm-video-cta h2.cta-heading{font-size:1.85rem;font-weight:400;text-transform:capitalize;margin-bottom:3rem;letter-spacing:0}.grm-video-related{position:relative}.grm-video-related h2.related-heading{color:#292929;text-transform:capitalize;font-size:1.85rem;line-height:2.4rem;margin-bottom:2.2rem}.grm-video-related .grm-vr{padding:0 0 1.4rem;position:relative;border-radius:.1rem;max-width: 430px;}.grm-video-related .grm-vr a{display:block}.grm-video-related .grm-vr h3 a{background-color:#edf1f3;font-size:1.28rem;padding:1rem 1rem 1.2rem;line-height:1.6rem;display:block}.grm-watch-video-card{content:'Watch video';position:absolute;top:100px;left:50%;z-index:1;line-height:1;padding:.9rem 1rem;background-color:#fff;box-shadow:0 3px 6px #000 29;border-radius:5px;color:#292929;transform:translateX(-50%)}.grm-watch-video-card svg{color:#1475df;margin-right:.5rem}body .cat-994 h1{color:#19247b;font-size:2.14rem}body .cat-994 .grm-watch-video-card{top:25%;font-size:1rem;padding:.8rem 1rem}body .cat-994 .elementor-column-gap-default>.elementor-column>.elementor-element-populated{padding:0}@media screen and (min-width:1024px){body .cat-994 .content{padding-right:3rem}}"
						}} />
						</>
					}
				</div>
			</div>
			{
				categoryId !== 4923 &&
				<GRMcontactForm 
					langCode={langCode}
					ctaText={
						videoCatArray.includes(categoryId) &&
						localTrans.sadTrans[langCode]
					}/>
			}
			
		</Layout>
	)
}

export default PlainPostTemplate

export const Head = ({ data }) => {
	const hasFeaturedImage = ( data.wpPost.featuredImage ) ? true : false
	
	data.wpPost.seo.locale = ( data.wpPost.language ) ?
		data.wpPost.language.locale : 'en_US'
	data.wpPost.seo.allLangs = []
	data.wpPost.seo.transUris = []

	data.wp.languages.forEach(lang => {
		data.wpPost.seo.allLangs.push(lang.locale)
	})

	data.wpPost.translations.forEach(subItem => {
		data.wpPost.seo.transUris.push(subItem.uri)
	})

	return( 
		<>
			<SEOhead data={data.wpPost.seo}
				hasFeaturedImage={hasFeaturedImage}
				customJsonLD={data.wpPost.customJsonLD}/>
			<HeadCSS data={data} /> 
		</>
	)
}

export const query = graphql`
	query(
		$id: String,
		$category: Int!
	) {
		wpPost(id: { eq: $id }) {
			title
			content
			elementorCss
			elementorData
			categories {
				nodes {
					databaseId
					name
				}
			}
			customContent
			customJsonLD
			featuredImage {
				node {
					uri
				}
			}
			language {
				slug
				locale
			}
			seo {
				metaDesc
				metaRobotsNofollow
				metaRobotsNoindex
				opengraphUrl
				opengraphType
				opengraphAuthor
				opengraphDescription
				opengraphImage {
					localFile {
						publicURL
					}
				}
				opengraphTitle
				title
				twitterDescription
				twitterTitle
				schema {
                    raw
                }
			}
			translations {
				uri
			}
		}
		allWpPost(
            limit: 3
            sort: {
                date: DESC, 
            }
            filter: {
                categories: {
                    nodes: {
                        elemMatch: {
                            databaseId: {
                                eq: $category
                            }
                        }
                    }
                }, 
                id: {
                    ne: $id
                }
            }
        ) {
            nodes {
                id
                title
                uri
                featuredImage {
                    node {
                        altText
                        localFile {
                            publicURL
                        }
                    }
                }
            }
        }
		wp {
			elementorCssKit
			elementorHF
			languages {
				locale
			}
			grmPaginationPages
        }
	}
`